import { type ClassValue, clsx } from 'clsx'
import { getToken } from './auth'

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}

export function formatFileSize(bytes?: number): string {
  if (!bytes) return 'Unknown size'
  
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  if (bytes === 0) return '0 Bytes'
  
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i]
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function getStatusText(status: string): string {
  const statusMap = {
    published: '已发布',
    unlisted: '未发布',
    archived: '已归档',
  }
  return statusMap[status as keyof typeof statusMap] || status
}

export function getStatusColor(status: string): string {
  const colorMap = {
    published: 'bg-green-100 text-green-800',
    unlisted: 'bg-yellow-100 text-yellow-800',
    archived: 'bg-gray-100 text-gray-800',
  }
  return colorMap[status as keyof typeof colorMap] || 'bg-gray-100 text-gray-800'
}

export function buildAuthorizedUrl(url?: string | null): string | undefined {
  if (!url) return undefined
  const token = getToken()
  if (!token) return url
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}token=${encodeURIComponent(token)}`
}
